import React, { useEffect } from 'react'
import { createTheme, ThemeProvider, Theme, StyledEngineProvider, adaptV4Theme } from '@mui/material/styles'
import { useLocation } from 'react-router-dom'
import { switchTheme } from '../redux/actions'
import { useAppDispatch, useAppSelector } from '../store'

declare module '@mui/styles/defaultTheme' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

const themeViewsList = {}

const loadTheme = async (location: any, previousThemeName: any, dispatch: any) => {
    let themeToSwitch = 'default'

    Object.keys(themeViewsList).forEach((key) => {
        const viewList = themeViewsList[key]
        const hasToSwitchTheme = viewList.filter((view: any) => view === location.pathname).length > 0
        if (hasToSwitchTheme) {
            themeToSwitch = key
        }
    })

    if (themeToSwitch !== previousThemeName) {
        dispatch(switchTheme(themeToSwitch))
    }
}

const ThemeWrapper = (props: any) => {
    const { children } = props
    const themeStore = useAppSelector((state) => state.theme)
    const theme = createTheme(adaptV4Theme(themeStore.theme.theme))
    const dispatch = useAppDispatch()
    const location = useLocation()

    useEffect(() => {
        loadTheme(location, themeStore.theme.name, dispatch)
    }, [location, dispatch])

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </StyledEngineProvider>
    )
}

export default ThemeWrapper
